import Page from 'flarum/components/Page';
import Link from 'flarum/components/Link';
import AboutHeader from '../../components/AboutContent/AboutHeader';

export default class AboutPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);

    // Send history push
    app.history.push('about');

    this.bodyClass = 'App--AboutPage';

    app.setTitle('Over KhatVongSong');
  }

  view() {
    return (
      <div className={'Site-AboutPage'}>
        <div className={'container'}>
          <AboutHeader selected={'about'} />

          {/* <div className={"content-box"}>
            Content
          </div> */}

          <div className={'About-statistics'}>
            <div className={'content-box'}>
              <span className={'statistics-icon fas fa-users'} />
              <span className={'statistics-counter'}>450+</span>
              <span className={'statistics-type'}>Người dùng</span>
            </div>
            <div className={'content-box'}>
              <span className={'statistics-icon far fa-file-alt'} />
              <span className={'statistics-counter'}>350+</span>
              <span className={'statistics-type'}>Thảo luận</span>
            </div>
            <div className={'content-box'}>
              <span className={'statistics-icon far fa-comments'} />
              <span className={'statistics-counter'}>2100+</span>
              <span className={'statistics-type'}>Bài viết</span>
            </div>
            <div className={'content-box'}>
              <span className={'statistics-icon fas fa-user-tag'} />
              <span className={'statistics-counter'}>1200+</span>
              <span className={'statistics-type'}>Huy hiệu</span>
            </div>
            <div className={'content-box'}>
              <span className={'statistics-icon fas fa-users'} />
              <span className={'statistics-counter'}>3</span>
              <span className={'statistics-type'}>Nhóm</span>
            </div>
            <div className={'content-box'}>
              <span className={'statistics-icon fas fa-tag'} />
              <span className={'statistics-counter'}>47</span>
              <span className={'statistics-type'}>Thể loại</span>
            </div>
            <div className={'content-box'}>
              <span className={'statistics-icon far fa-thumbs-up'} />
              <span className={'statistics-counter'}>550+</span>
              <span className={'statistics-type'}>Lượt thích</span>
            </div>
            <div className={'content-box'}>
              <span className={'statistics-icon fas fa-bell'} />
              <span className={'statistics-counter'}>2000+</span>
              <span className={'statistics-type'}>Thông báo</span>
            </div>
            <div className={'content-box'}>
              <span className={'statistics-icon fas fa-blog'} />
              <span className={'statistics-counter'}>20+</span>
              <span className={'statistics-type'}>Nhật ký</span>
            </div>
            <div className={'content-box'}>
              <span className={'statistics-icon fas fa-heartbeat'} />
              <span className={'statistics-counter'}>7</span>
              <span className={'statistics-type'}>Hoạt động</span>
            </div>
            <div className={'content-box'}>
              <span className={'statistics-icon fas fa-tags'} />
              <span className={'statistics-counter'}>800+</span>
              <span className={'statistics-type'}>Thẻ</span>
            </div>
            <div className={'content-box'}>
              <span className={'statistics-icon fas fa-chart-line'} />
              <span className={'statistics-counter'}>1000+</span>
              <span className={'statistics-type'}>Truy cập</span>
            </div>
          </div>

          <div class="content-box content-padding">
            <h3>KVS in short</h3>

            <p>
                Chúng tôi là <strong>KhatVongSong</strong>, một diễn đàn dành cho các nhà phát triển.
            </p>

            <p>
                Chúng tôi là một cộng đồng trẻ đầy ý tưởng, sáng tạo và nỗ lực. Cùng với các thành viên tích cực của mình, chúng tôi chia sẻ các dự án của mình và cùng nhau xây dựng chúng, chúng tôi giúp đỡ lẫn nhau và tạo hướng dẫn để những người khác hiểu rõ hơn về mã và hệ thống!
            </p>

            <p>
                <strong>KVS phù hợp với ai?</strong>
                <br /> Những gì chúng tôi cung cấp diễn đàn của chúng tôi cho:
            </p>

            <ul>
                <li>Những người muốn tham gia cộng đồng kỹ thuật số</li>
                <li>Dự án trang web</li>
                <li>Dự án trò chơi</li>
                <li>Quản trị viên hệ thống</li>
                <li>Tư vấn lưu trữ</li>
                <li>Vấn đề, chúng ta sẽ cùng nhau giải quyết</li>
                <li>Nhà thiết kế</li>
            </ul>

            <p>
                <strong>Xây dựng với chúng tôi!</strong>
                <br />
                <Link href="#" rel="ugc noopener" target="_self"> Hãy cho chúng tôi biết về dự án của bạn
                </Link>
                ,{' '}
                <Link href="#" rel="ugc noopener" target="_self"> yêu cầu trợ giúp
                </Link>{' '} nếu bạn cần và{' '}
                <Link href="#" rel="ugc noopener" target="_self"> đưa ra hướng dẫn
                </Link>{' '} nếu bạn muốn chia sẻ kiến ​​thức bạn có! Hãy là một phần của một cộng đồng mới.
            </p>

            <p>Đây là chúng tôi, KhatVongSong.</p>
        </div>
        </div>
      </div>
    );
  }
}
